package or.garden.manager.features.notes

import androidx.compose.runtime.*
import or.garden.manager.components.CardSkeleton
import or.garden.manager.domain.model.NoteData
import or.garden.manager.features.notes.components.NoteEditView
import or.garden.manager.features.notes.components.WebNoteCard
import org.jetbrains.compose.web.dom.*

@Composable
fun NotesScreen(
    notes: List<NoteData>,
    isLoading: Boolean,
    isSaving: Boolean,
    externalAddTrigger: Int,
    onSaveNote: (NoteData?, String, String, () -> Unit) -> Unit,
    onDeleteNote: (Int) -> Unit
) {
    var isNoteEditorActive by remember { mutableStateOf(false) }
    var selectedNoteForEdit by remember { mutableStateOf<NoteData?>(null) }
    
    var noteTitle by remember { mutableStateOf("") }
    var noteContent by remember { mutableStateOf("") }

    fun resetEditor() {
        selectedNoteForEdit = null
        noteTitle = ""
        noteContent = ""
    }

    LaunchedEffect(externalAddTrigger) {
        if (externalAddTrigger > 0) {
            resetEditor()
            isNoteEditorActive = true
        }
    }

    if (isNoteEditorActive) {
        NoteEditView(
            selectedNote = selectedNoteForEdit,
            noteTitle = noteTitle,
            onTitleChange = { noteTitle = it },
            noteContent = noteContent,
            onContentChange = { noteContent = it },
            isSaving = isSaving,
            onSave = {
                onSaveNote(selectedNoteForEdit, noteTitle, noteContent) {
                    isNoteEditorActive = false
                    resetEditor()
                }
            },
            onBack = { isNoteEditorActive = false }
        )
    } else if (isLoading) {
        Div({
            classes("grid", "grid-cols-1", "md:grid-cols-2", "xl:grid-cols-3", "gap-4", "md:gap-6")
        }) {
            repeat(6) { CardSkeleton() }
        }
    } else if (notes.isEmpty()) {
        Div({ classes("text-center", "py-20", "text-gray-400") }) {
            I({ classes("fas", "fa-sticky-note", "text-4xl", "mb-4") })
            H2 { Text("Nema sačuvanih bilješki.") }
            Button({
                classes("mt-4", "bg-emerald-600", "text-white", "px-6", "py-2", "rounded-xl", "font-bold")
                onClick {
                    resetEditor()
                    isNoteEditorActive = true
                }
            }) { Text("Dodaj prvu bilješku") }
        }
    } else {
        Div({
            classes("grid", "grid-cols-1", "md:grid-cols-2", "xl:grid-cols-3", "gap-4", "md:gap-6")
        }) {
            notes.forEach { note ->
                WebNoteCard(
                    note = note,
                    onEdit = {
                        selectedNoteForEdit = note
                        noteTitle = note.title
                        noteContent = note.content
                        isNoteEditorActive = true
                    },
                    onDelete = { onDeleteNote(note.id) }
                )
            }
        }
    }
}
